/*
Values available for the fulfillmentType property
found on the fulfillmentPlan and fulfillment entity models:
*/

// 'External' is when a merchant delegates the fulfillment process
// to an external fulfillment provider.
const External = 'External';

// 'Manual' is when a merchant uses the 'mark as shipped' workflow
// indicating that they have processed the fulfillment outside
// of ShipStation.
const Manual = 'Manual';

// 'Shipment' is when a merchant uses ShipStation to purchase a label
// via our fulfillment planner.
const Shipment = 'Shipment';

export const FulfillmentType = {
  External,
  Manual,
  Shipment,
};
